import { Page } from "../../models/page";
import { twclsx } from "../../utils/cssUtil";
import { useSearchParams } from "react-router-dom";
import { StoreKey } from "../../models/cacheKey";
import { HTMLAttributes } from "react";

interface PaginationProps extends HTMLAttributes<any> {
  page?: Page;
  maxDisplayButtons?: number;
}

export function Pagination({
  page,
  className,
  maxDisplayButtons = 9,
}: PaginationProps) {
  const total = page?.totalPages || 1;
  const current = page?.currentPage || 0;
  const [searchParams, setSearchParams] = useSearchParams();

  const [minTemp, maxTemp] = [
    current - Math.floor((maxDisplayButtons - 3) / 2),
    current + Math.ceil((maxDisplayButtons - 3) / 2),
  ];
  const midMin = minTemp - Math.max(maxTemp - (total - 2), 0);
  const midMax = maxTemp + Math.max(1 - minTemp, 0);
  const prevElapsed = total > maxDisplayButtons && midMin > 1;
  const postElapsed = total > maxDisplayButtons && midMax < total - 2;

  return (
    <>
      <div className={twclsx("join justify-center", className)}>
        {[...Array(total)].map((_, i) => {
          return (
            (i === 0 || i === total - 1 || (i >= midMin && i <= midMax)) && (
              <button
                key={i}
                className={twclsx(
                  "btn btn-xs",
                  total > 1 && "join-item",
                  i === page?.currentPage && "btn-active btn-primary",
                  ((prevElapsed && i === midMin) ||
                    (postElapsed && i === midMax)) &&
                    "btn-disabled btn-ghost",
                )}
                onClick={(e) => {
                  if (i === page?.currentPage) {
                    return;
                  }
                  searchParams.set(StoreKey.queryPage, `${i + 1}`);
                  setSearchParams(searchParams);
                }}
              >
                {(prevElapsed && i === midMin) ||
                (postElapsed && i === midMax) ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 16 16"
                    fill="currentColor"
                    className="w-4 h-4"
                  >
                    <path d="M2 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM6.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM12.5 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" />
                  </svg>
                ) : (
                  i + 1
                )}
              </button>
            )
          );
        })}
      </div>
    </>
  );
}
